import React from "react";
import { Col, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import "./index.css";

const TaskNoteHeader = ({ data }) => {
  const profileData = useSelector((state) => state?.dashboard?.profileData?.patientData);
  return (
    <Row className="task-note-header">
      <Col md={8}>
        <Row>
          <Col md="6">
            <p>
              {profileData?.firstName} {profileData?.lastName}
            </p>
            <p style={{ textTransform: "uppercase" }}>
            {profileData?.city ? `${profileData?.city}, ` : null}
            {profileData?.state}{" "}
            {profileData?.zipCode}
            </p>
          </Col>
          <Col md="6">
            <p>{data?.taskMetadata?.patientMobileNumber}</p>
            <p>{data?.taskMetadata?.email}</p>
          </Col>
        </Row>
      </Col>
      <Col md="4"></Col>
    </Row>
  );
};

export default TaskNoteHeader;